import { useState } from "react";
import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { Breadcrumb, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useUrlSearchParams } from "use-url-search-params";
import { useNavigate } from "react-router";

import { useServiceDocsList } from "modules/serviceRegister/hooks";

import Pagination from "containers/Pagination";
import Button from "components/Button";
import * as Icons from "assets/icons";
import FilterList from "./components/FilterList";

const ServiceDocsList = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  const [search, setSearch] = useState(0);

  const handleFilterChange = (filter) => {
    setParams({
      ...filter,
      page: 1,
      perPage: 10,
    });
  };

  const defaultParams = {
    search,
    page: params.page,
    perPage: params.perPage || 10,
    filter: [
      {
        key: "organization.id",
        operation: "=",
        value: params.organization_id,
        type: "STRING",
      },
    ]
  };

  const { items, meta, isFetched } = useServiceDocsList({ params: defaultParams });

  return (
    <>
      <Container>
        <Spacer size={35} />

        <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">
            {t("home")}
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            {t("service_register")}
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            {t("service_register_stats")}
          </Breadcrumb.Item>
        </Breadcrumb>

        <Spacer size={32} />

        <Title
          align="left"
          text={t("service_register_stats")}
        />

        <Spacer size={40} />
        <FilterList {...{ params, setParams: handleFilterChange, setSearch }} />

        <Spacer size={20} />

        <Table
          rowKey="id"
          columns={[
            {
              title: "№",
              render: (_, __, index) =>
                (meta.current - 1) * meta.perPage + index + 1,
            },
            {
              key: "serviceName",
              title: t("column_service_name"),
              dataIndex: ["serviceName", i18n.language],
            },
            {
              key: "organization",
              title: t("organization"),
              dataIndex: ["organization", "name", i18n.language],
            },
            {
              key: "count",
              title: t("document_count"),
              dataIndex: "count",
            },
            {
              key: "actions",
              render: (_, record) => (
                <Button
                  background="secondary"
                  color="secondary"
                  border="none"
                  radius="xs"
                  iconOnly
                  onClick={() =>
                    navigate(
                      `/service-register/view/${record.id}`,
                    )
                  }
                >
                  <Icons.ArrowRight />
                </Button>
              ),
            },
          ]}
          dataSource={items}
          pagination={false}
          loading={!isFetched}
          onRow={(record) => ({
            onClick: () =>
              navigate(
                `/service-register/view/${record.id}`,
              ),
          })}
        />

        <Spacer size={32} />

        <Pagination
          current={meta.current}
          perPage={meta.perPage}
          total={meta.totalPages}
          currentItems={items.length}
          totalItems={meta.totalItems}
          onChange={(page) =>
            setParams({ page })
          }
          onPerPageChange={(perPage) =>
            setParams({
              perPage,
              page: 1,
            })
          }
        />

        <Spacer size={140} />
      </Container>
    </>
  );
};

export default ServiceDocsList;
